import { render, staticRenderFns } from "./PanelAutoScroll.vue?vue&type=template&id=52adf39b&scoped=true&"
import script from "./PanelAutoScroll.vue?vue&type=script&lang=js&"
export * from "./PanelAutoScroll.vue?vue&type=script&lang=js&"
import style0 from "./PanelAutoScroll.vue?vue&type=style&index=0&id=52adf39b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52adf39b",
  null
  
)

export default component.exports